import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {ItemListItems} from "./ItemListItems";

export default function ItemList(props) {
    const [data, setData] = useState({items: [], loading: true});
    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Home'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        var url = API_URL + '/api/private/tanker/v1/items'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({items: data, loading: false});
            });
    }

    return <div>
        <ItemListItems items={data.items}/>
    </div>
}


